import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
	Sentry.init({
		dsn,
		environment: process.env.REACT_APP_PROJECT_ID || "unknown",
		sendDefaultPii: false,
		tracesSampleRate: 0,
	});
}
